/* SortTypeEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
// const { typeLabelsList, getTypeData, typeDataByLabel } = require("../CustomFieldsConstants");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class SortTypeEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this.rootElement.classList.add("select");
        this.rootElement.classList.add("sort-type-editor");
        // this._maxSortOrder = 0;
        this._grid = args.grid;
        this._maxSortOrder = this._grid.maxSortOrder;
        const dataType = this._itemData && this._itemData.dataType;
        let ascLabel, descLabel;
        if (dataType) {
            switch (dataType) {
                case "number":
                    ascLabel = "Lowest first";
                    descLabel = "Highest first";
                    break;
                case "unixTime":
                    ascLabel = "Oldest first";
                    descLabel = "Newest first";
                    break;
                default:
                    ascLabel = "A to Z";
                    descLabel = "Z to A";
                    break;
            }
        }
        this.input.setOptions([
            {
                label: ascLabel,
                value: "asc"
            },
            {
                label: descLabel,
                value: "desc"
            },
            {
                label: "None",
                value: ""
            }
        ]);
    }

    applyValue(item, state) {
        // console.log(item, state);
        super.applyValue(item, state);
        const sortType = state;
        if (!state) {
            Object.assign(item, {
                sortType,
                sortOrder: undefined
            });
        } else {
            let _sortOrder;
            if (item.sortOrder || item.sortOrder === 0) {
                _sortOrder = item.sortOrder;
            } else {
                _sortOrder = this._maxSortOrder;
                this._grid.maxSortOrder = +1;
            }
            Object.assign(item, {
                sortType,
                sortOrder: _sortOrder
            });
        }
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        const combobox = new SingleComboBoxControl({
            showFilter: false,
            darkTheme: false,
            adjustWidth: true,
            allowClear: false
        });
        return combobox;
    }
}

module.exports = SortTypeEditor;
